import { PATH } from '@/shared/constants';

export const openNavigatorShare = (title: string, url: string) => {
  navigator.share({ title, url });
};

export const getShareParams = (title: string, articleId: string) => {
  const shareUrl = `${process.env.NEXT_PUBLIC_APP_BASE_URL}${PATH.DETAIL}/${articleId}`;

  return { shareTitle: `[요즘IT] ${title}`, shareUrl };
};
